import styles from "styled-components";
import "@fontsource/lexend";

/* Page wrapper */
export const ContactPage = styles.div`
  background: #282c34;
  min-height: 100vh;
  padding: 32px 16px 60px;
  display: flex;
  justify-content: center;
  color: #fff;
  font-family: "Lexend";
`;

/* Constrain content width */
export const ContactInner = styles.div`
  width: 100%;
  max-width: 1180px;
`;

/* Generic row: side-by-side on desktop, stacked on mobile */
export const ContactRow = styles.div`
  display: flex;
  gap: 28px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
  }
`;

/* Column: half width on desktop, full on mobile */
export const ContactCol = styles.div`
  flex: 1 1 0;
  min-width: 0;            /* avoid overflow */
  max-width: 560px;        /* keep readable */
  width: 100%;
  @media (max-width: 768px) {
    width: 100%;
    max-width: none;
  }
`;

/* Text blocks */
export const ContactContentTitle = styles.h3`
  margin: 0 0 10px 0;
  font-size: 22px;
  letter-spacing: 0.5px;
`;

export const ContactContentText = styles.div`
  color: #fff;
  font-size: 16px;
  line-height: 1.7;


  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const ContactContentTextFooter = styles.div`
  text-align: center;
  padding-top: 14px;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const EmailLink = styles.a`
  color: #fff;
  text-decoration: none;
  overflow-wrap: anywhere;
  &:hover { text-decoration: underline; }
`;

/* Image */
export const ContactImage = styles.img`
  display: block;
  width: 100%;
  height: auto;
  border-radius: 24px;
  background: #282c34;
  box-shadow: 0 12px 30px rgba(0,0,0,0.35);
`;

/* Form */
export const ContactFormWrapper = styles.form`
  display: flex;
  flex-direction: column;
  gap: 14px;
  color: #fff;
  width: 100%;
`;

export const ContactFormLabel = styles.label`
  font-size: 14px;
  opacity: 0.9;
`;

export const ContactFormElementInput = styles.input`
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,0.18);
  background: #1b1b1d;
  color: #fff;
  outline: none;
  &:focus {
    border-color: #012D9C;
    box-shadow: 0 0 0 3px rgba(1,45,156,0.35);
  }
`;

export const ContactFormElementTextarea = styles.textarea`
  min-height: 140px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,0.18);
  background: #1b1b1d;
  color: #fff;
  resize: vertical;
  outline: none;
  &:focus {
    border-color: #012D9C;
    box-shadow: 0 0 0 3px rgba(1,45,156,0.35);
  }
`;

export const ContactFormElementSubmit = styles.button`
  align-self: flex-start;
  padding: 12px 18px;
  border-radius: 10px;
  border: 0;
  cursor: pointer;
  font-weight: 700;
  background: #012D9C;
  color: #FFE0DF;
  box-shadow: 0 6px 18px rgba(1,45,156,0.35);
  transition: transform 0.08s ease, opacity 0.2s ease;

  &:hover { opacity: 0.95; }
  &:active { transform: translateY(1px) scale(0.99); }

  @media (max-width: 768px) {
    align-self: stretch; /* full width button on mobile */
  }
`;

export const ButtonRow = styles.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 24px;
  padding-right: 20%;
  gap: 10px;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
    padding-right: 0;
  }
`;

export const CTAButton = styles.a`
  text-align: center;
  text-decoration: none;
  font-family: "Lexend";
  font-weight: 700;
  font-size: 14px;
  padding: 8px 10px;
  border-radius: 10px;
  background: #012D9C;
  color: #FFE0DF;
    border: none;
  outline: none;
  appearance: none;
  box-shadow: 0 4px 14px rgba(1,45,156,0.35);
  transition: transform 0.08s ease, opacity 0.2s ease;
  &:hover { opacity: 0.95; }
  &:active { transform: translateY(1px) scale(0.99); }
`;